import { createContext } from 'react';
import type { ITopError } from './ITopError';

export const TopErrorListContext = createContext<ReadonlyArray<ITopError>>([]);
TopErrorListContext.displayName = 'TopErrorListContext';
